(() => {
  'use strict';
function saleState(config, now = Date.now()) {
  const hidden = {state: 'hidden'};
  if (!config || !Number.isFinite(now) || [config.START, config.TZ].some(v => typeof v !== 'string' || !v || /\[|\]/.test(v))) return hidden;
  const explicitOffset = /T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})$/;
  if (!explicitOffset.test(config.START) || (config.END && !explicitOffset.test(config.END))) return hidden;
  try { new Intl.DateTimeFormat('en-US', {timeZone: config.TZ}).format(); } catch { return hidden; }
  const start = Date.parse(config.START), end = config.END ? Date.parse(config.END) : Infinity;
  if (!Number.isFinite(start) || (config.END && !Number.isFinite(end)) || end <= start) return hidden;
  if (now >= end) return {state: 'closed', target: config.END, seconds: 0};
  const preOpen = now < start;
  if (!preOpen && !config.END) return {state: 'live', openEnded: true};
  return {state: preOpen ? 'pre-open' : 'live', target: preOpen ? config.START : config.END, seconds: Math.ceil(((preOpen ? start : end) - now) / 1000)};
}

  function buyAllowed(config, hideAfterEnd, now = Date.now()) {
    if ([config.START, config.END, config.TZ].every(v => !v)) return true;
    const state = saleState(config, now).state;
    return state === 'live' || (state === 'closed' && !hideAfterEnd);
  }
  function scarcity(tracked, quantity) {
    if (!tracked) return '';
    const n = Number(quantity);
    return n === 1 ? 'Only 1 available in this release' : Number.isInteger(n) && n >= 2 && n <= 3 ? `Only ${n} left` : '';
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {saleState, buyAllowed, scarcity};
  if (typeof document === 'undefined') return;
  if (window.__pcsSaleCountdown) { window.__pcsSaleCountdown.scan(document); return; }
  const timers = new Map();
  function mount(root) {
    if (timers.has(root)) return;
    const config = {START: root.dataset.start, END: root.dataset.end, TZ: root.dataset.tz};
    root.querySelectorAll('.pcs-cart-form').forEach(form => {
      function updateScarcity() {
        const select = form.querySelector('select[name="id"]');
        const selected = select ? select.selectedOptions[0] : form.querySelector('input[name="id"]');
        const label = form.parentElement.querySelector('[data-pcs-scarcity]');
        label.textContent = scarcity(selected.dataset.tracked === 'true', selected.dataset.quantity);
        label.hidden = !label.textContent;
      }
      form.addEventListener('change', updateScarcity);
      form.addEventListener('submit', event => {
        if (!buyAllowed(config, root.dataset.hideAfterEnd === 'true')) event.preventDefault();
      });
      updateScarcity();
    });
    const strip = root.querySelector('[data-pcs-count]');
    if (!strip) return;
    function tick() {
      const state = saleState(config);
      const status = root.querySelector('[data-pcs-status]');
      if (status) status.textContent = state.state === 'pre-open'
        ? 'Insiders access begins Thursday, October 15 at 1 PM ET.'
        : state.state === 'live'
          ? 'The collection is open. Browse the pieces below and shop through the regular Oaks Poke Box checkout.'
          : '';

      const allowed = buyAllowed(config, root.dataset.hideAfterEnd === 'true');
      root.querySelectorAll('[data-pcs-buy]').forEach(button => { button.hidden = !allowed; button.disabled = !allowed; });
      strip.hidden = state.state === 'hidden' || state.openEnded === true;
      if (strip.hidden) return;
      const closed = state.state === 'closed';
      root.querySelector('[data-pcs-label]').textContent = closed ? 'Release ended' : state.state === 'pre-open' ? 'Collection opens in' : 'Release closes in';
      const date = root.querySelector('[data-pcs-date]');
      date.setAttribute('datetime', state.target);
      date.textContent = new Intl.DateTimeFormat('en-US', {timeZone: config.TZ, dateStyle: 'full', timeStyle: 'long'}).format(new Date(state.target));
      root.querySelector('[data-pcs-closed]').hidden = !closed;
      root.querySelector('[data-pcs-units]').hidden = closed;
      const s = state.seconds;
      const units = {d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60};
      root.querySelectorAll('[data-pcs-u]').forEach(el => { el.textContent = String(units[el.dataset.pcsU]).padStart(2, '0'); });
    }
    tick();
    timers.set(root, saleState(config).state === 'hidden' ? null : setInterval(tick, 1000));
  }
  function scan(target) {
    if (target.matches && target.matches('[data-pcs-root]')) mount(target);
    target.querySelectorAll('[data-pcs-root]').forEach(mount);
  }
  function unmount(target) {
    for (const [root, id] of timers) {
      if (root === target || target.contains(root)) { if (id !== null) clearInterval(id); timers.delete(root); }
    }
  }
  window.__pcsSaleCountdown = {scan};
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => unmount(event.target));
  scan(document);
})();
